import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`忘了是先喜欢上了文字还是先注意到了歌词，只知道有心和无意的差别确实很大。`}</p>
    <p>{`若有心，一叶知秋，见微知著。若无意，星河璀璨，浮光掠影。`}</p>
    <p>{`《山河令》爆火之后一首名为《羽落》的歌也火了。`}</p>
    <p>{`确切地说，是火了那句`}<strong parentName="p">{`羽落尽长安，难求枫林晚，四季交替人不换。`}</strong></p>
    <p>{`不同心境，不同感受。`}</p>
    <p>{`温客行和周子舒也好，龚俊和张哲瀚也好。山上的风景，终归是值得山人的留恋。`}</p>
    <p>{`近期抖音上看到一些有趣的文案，让我再次体会到了文字的魅力。`}</p>
    <p>{`恋爱时：`}<strong parentName="p">{`两个成年人深思熟虑的决定`}</strong>{`。`}</p>
    <p>{`分开时：`}<strong parentName="p">{`两个成年人深思熟虑的决定`}</strong>{`。`}</p>
    <p>{`复合时：`}<strong parentName="p">{`两个成年人深思熟虑的决定`}</strong>{`。`}</p>
    <p>{`默默地吐槽一句，深思熟虑了个啥？`}</p>
    <p>{`相比之下，那句古风文案还是有点东西。`}</p>
    <p>{`恋爱时：`}<strong parentName="p">{`从此烟雨落京城,一人撑伞两人行。`}</strong></p>
    <p>{`分开时：`}<strong parentName="p">{`从此烟雨落京城,一人撑伞一人行。`}</strong></p>
    <p>{`复合时：`}<strong parentName="p">{`从此烟雨落京城,伊人撑伞故人行。`}</strong></p>
    <p>{`比较有意思的是，附带嘲讽技能：`}<strong parentName="p">{`烟雨再次落京城，唯君一人雨中停。`}</strong></p>
    <p>{`啊...这，不如找个不下雨的地方？或者踩点卖雨伞，必然能狠狠赚一笔，商机可遇不可求。`}</p>
    <p>{`还有那些看似不合理，但是读起来又没有什么违和感的句子。`}</p>
    <p><strong parentName="p">{`巴山楚水凄凉地，responsibility。`}</strong></p>
    <p>{`没想到英语还能这样玩，果真是有点东西，以一当七且当仁不让。`}</p>
    <p><strong parentName="p">{`男儿当自强，对接贴花黄。`}</strong></p>
    <p>{`努力还是有必要的，尤其是精致的努力。如此可爱，一定要是男孩子。`}</p>
    <p><strong parentName="p">{`垂死病中惊坐起，扶摇直上九万里。`}</strong></p>
    <p>{`我不求道，道自然来。挥一挥衣袖，天门为我而开。`}</p>
    <p><strong parentName="p">{`天堂有路你不走，学海无涯苦作舟。`}</strong></p>
    <p>{`曾是天涯逍遥客，后被仇家追杀，出世剑转入世笔。学海泛舟间，不知绘了几幅丹青？`}</p>
    <p><strong parentName="p">{`人生得意须尽欢，英雄难过美人关。`}</strong></p>
    <p>{`无非是醒掌天下权，醉卧美人膝。道可道，非常道。`}</p>
    <p><strong parentName="p">{`两岸猿声啼不住，惊起一滩鸥鹭。`}</strong></p>
    <p>{`凤飞翱翔兮，四海求凰。雄凤栖于白帝城，见此情此景，作赋《凤求凰》，凤清漫天。`}</p>
    <p>{`那日起，世人皆知，白帝城，不只有遗孤。`}</p>
    <p><strong parentName="p">{`爷娘闻女来，自挂东南枝。`}</strong></p>
    <p>{`廉颇老矣，尚能饭否？东南飞的孔雀，一锅可否放下？`}</p>
    <p><strong parentName="p">{`仰天大笑出门去，归来倚杖自叹息。`}</strong></p>
    <p>{`太白持剑，三尺青锋，于人间无敌。子美倚杖，破败茅房，为秋风所破。`}</p>
    <p>{`风声呖呖，茅屋中传出一阵叹息声：唉，太白兄，千金散尽，如何才能还复来？`}</p>
    <p>{`似有青莲划破秋风，天地间一道快意豪言入耳：哈哈蛤，酒后戏言，子美兄莫当真。`}</p>
    <p>{`那一日，卖火柴的小女孩燃尽最后一根火柴。`}</p>
    <p>{`快乐是什么？快乐就是见喜欢的人，做想做的事，和喜欢的人做想做的事。`}</p>
    <p><strong parentName="p">{`水中有明月，碎碎圆圆。心上有良人，平平安安。`}</strong></p>
    <p>{`这一世，太多欢喜，三言两语，如何诉说得完？`}</p>
    <p>{`情如风雪无常，`}</p>
    <p>{`却是一动即殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      